import moment from 'moment';
import { useCallback } from 'react';

import useTriggeredRequest from '@api/hooks/useTriggeredRequest';
import AccountClientRequests from '@api/requests';
import ApplicationDetailsInterface from '@api/requests/applications/interfaces/ApplicationDetailsInterface.interface';

import downloadDocuments from '@utils/downloadDocuments';

export function useDownloadApplicationPDF(application: ApplicationDetailsInterface) {
	const { startRequest: download, isPending } = useTriggeredRequest(
		AccountClientRequests.Applications.downloadApplication,
	);

	const handleDownloadApplicationPDF = useCallback(async () => {
		const res = await download({
			application_id: application.id,
		});

		const filePrefix = [application.uid, moment().unix()].filter(Boolean).join('_');

		downloadDocuments(
			{
				fileStream: res,
				contentType: 'application/pdf',
			},
			`${filePrefix}.pdf`,
		);
	}, [application.id, application.uid, download]);

	return {
		handleDownloadApplicationPDF,
		isApplicationPDFDownloading: isPending,
	};
}
